
export default class DialogUI {
    constructor(group, gameState) {
        this.group = group;
        this.gameState = gameState;
        this.dialogBitmap = game.add.bitmapData(800, 400);
        let ctx = this.dialogBitmap.ctx;
        ctx.fillStyle = 'black';
        ctx.fillRect(0, 0, this.dialogBitmap.width, this.dialogBitmap.height);
        ctx.lineWidth = 3;
        ctx.strokeStyle = '#4C72A0';
        ctx.strokeRect(1, 1, this.dialogBitmap.width - 2, this.dialogBitmap.height - 2);
        ctx.strokeRect(1, 1, this.dialogBitmap.width - 2, 40);
        ctx.fillStyle = '#4C72A0';
        ctx.fillRect(0, 8, this.dialogBitmap.width, 26);


        this.dialogSprite = game.add.sprite(game.world.width / 2, game.world.height / 2 - this.dialogBitmap.height / 2, this.dialogBitmap, 0, group);
        this.dialogSprite.visible = false;
        this.dialogSprite.anchor.set(0.5, 0);


        this.mainText = game.add.bitmapText(this.textOffset, 70, "nokia", "", 20, this.group);
        this.mainText.alpha = 0;
        this.mainText.maxWidth = this.dialogSprite.width - 40;
        this.mainTextHighlighted = game.add.bitmapText(this.textOffset, 70, "nokia", "", 20, this.group);
        this.mainTextHighlighted.alpha = 0;
        this.mainTextHighlighted.maxWidth = this.dialogSprite.width - 40;
        this.dialogSprite.addChild(this.mainText);
        this.dialogSprite.addChild(this.mainTextHighlighted);
        this.mainText.tint = 0x2680A9;
        this.mainTextHighlighted.tint = 0x997b55;

        this.logHeader = game.add.bitmapText(this.textOffset, 10, "nokia", "", 23, group);
        this.logHeader.tint = 0x000000;
        this.dialogSprite.addChild(this.logHeader);
        this.cursor = game.add.bitmapText(this.textOffset, 10, "nokia", ">", 20, group);
        this.cursor.visible = false;
        this.cursor.tint = 0x64BEE3;
        this.dialogSprite.addChild(this.cursor);
        this.options = [];

        this.status = game.add.bitmapText(10, this.dialogSprite.height / 2, "nokia", "", 20 * 1.5, group);
        this.status.maxWidth = this.dialogSprite.width / 2 - 20;
        this.dialogSprite.addChild(this.status);
        this.status.visible = false;
        this.status.tint = 0xD79847;

        this.gifContainer = document.createElement('img');
        document.body.appendChild(this.gifContainer);
        this.gifContainer.style.position = "absolute";
        this.gifContainer.style.left = "-1000px";
        this.gifContainer.style.maxHeight = "300px";
        this.gifContainer.style.border = "2px solid gray";
    }

    get textOffset() {
        return 20 - this.dialogSprite.width / 2;
    }

    showDialog(dialog, onAnyOption = () => { }) {
        if (!this.dialogSprite.visible) {
            this.showWindow(() => {
                this.showDialog(dialog, onAnyOption);
            });
            return;
        }
        this._hideText(() => {
            this._showText(dialog, onAnyOption);
        })

    }

    showMinigame(hint, minigameCls, onStopCb) {
        this._hideText(() => {
            this._showText({ message: hint, options: [] });
            this.minigame = new minigameCls(this.textOffset, this.dialogSprite.height / 2, (...args) => {
                this.minigame.sprite.destroy();
                this.minigame = null;
                onStopCb(...args);
            });
            this.group.add(this.minigame.sprite);
            this.dialogSprite.addChild(this.minigame.sprite);
        });
    }



    _hideText(then) {
        for (let opt of this.options) {
            opt.texts.forEach(t => t.destroy());
        }
        this.onAnyClick = null;
        this.cursor.visible = false;
        this.status.visible = false;
        this.gifContainer.style.left = "-1000px";
        this.options = [];
        game.add.tween(this.mainText).to({ alpha: 0 }, 100, null, true).onComplete.addOnce(then);
        game.add.tween(this.mainTextHighlighted).to({ alpha: 0 }, 100, null, true);
    }

    _showText(dialog, onAnyOption = () => { }) {
        this.mainText.text = dialog.message.split("\n").map(t => t.trim()).join("\n").replace(/\*/g, '');
        this.mainTextHighlighted.text = dialog.message.indexOf('*') !== -1 ? dialog.message.split("\n").map(t => t.trim()).join("\n") : '';
        this.mainTextHighlighted.separatorCode = '*'.charCodeAt(0);
        this.mainTextHighlighted.updateText();

        if (dialog.gif) {
            this.gifContainer.src = dialog.gif;
            this.gifContainer.style.left = dialog.gifOffset.x + (game.canvas.getBoundingClientRect().left + (this.dialogSprite.x - game.camera.x + 80) /*+ this.dialogSprite.width/2*/) + "px";
            this.gifContainer.style.top = dialog.gifOffset.y + (game.canvas.getBoundingClientRect().top + (this.dialogSprite.y - game.camera.y) + 200) + "px";
        } else {
            this.gifContainer.style.left = "-1000px";
        }

        this.logHeader.text = this.gameState.generateLogRecordId();
        this.onAnyClick = onAnyOption;
        let baseY = this.dialogSprite.height / 2 + 23;
        let nr = 1;
        if (!dialog.options) {
            dialog.options = [{
                text: "Ok"
            }]
        }
        for (let opt of dialog.options) {
            let x = this.textOffset + 20;
            if (opt.condition === false && opt.secret) continue;
            let texts = [];
            let t1 = game.add.bitmapText(x, baseY, "nokia", opt.text.replace(/\*/g, ''), 20, this.group);
            t1.maxWidth = this.dialogSprite.width - 60;
            texts.push(t1);
            this.dialogSprite.addChild(t1);
            if (opt.text.indexOf('*') !== -1) {
                let t2 = game.add.bitmapText(x, baseY, "nokia", opt.text, 20, this.group);
                t2.maxWidth = this.dialogSprite.width - 60;
                t2.separatorCode = '*'.charCodeAt(0);
                t2.highlighted = true;
                t2.updateText();
                this.dialogSprite.addChild(t2);
                texts.push(t2);
            }
            this.options.push({ texts, selected: false, enabled: opt.condition !== false, nr: nr, callback: opt.callback });
            nr++;
            baseY += t1.height + 5;
        }
        let firstEnabled = this.options.find(o => o.enabled);
        if (firstEnabled) {
            firstEnabled.selected = true;
            this.cursor.visible = true;
        } else {
            this.cursor.visible = false;
        }
        game.add.tween(this.mainText).to({ alpha: 1 }, 100, null, true);
        game.add.tween(this.mainTextHighlighted).to({ alpha: 1 }, 100, null, true);
        this.redrawOptions();
        if (dialog.status) {
            this.status.visible = true;
            this.status.text = dialog.status;
            this.status.alpha = 0;
            this.status.y = this.dialogSprite.height / 2;
            game.add.tween(this.status).to({ y: this.status.y + 20, alpha: 1 }, 100, null, true);
        }
    }

    showWindow(onEnd = () => { }) {
        this.dialogSprite.visible = true;
        this.dialogSprite.scale.set(0, 1);
        game.add.tween(this.dialogSprite.scale).to({ x: 1 }, 200, null, true).onComplete.addOnce(onEnd);
        game.musician.playDialog();
        game.gameState.dialogShown = true;
    }

    hideWindow(onEnd = () => { }) {
        this._hideText(() => {
            game.add.tween(this.dialogSprite.scale).to({ x: 0 }, 100, null, true).onComplete.addOnce(() => {
                this.dialogSprite.visible = false;
                game.gameState.dialogShown = false;
                game.musician.playIdle();
                onEnd();
            });

        });
    }

    redrawOptions() {
        for (let opt of this.options) {
            for (let txt of opt.texts) {
                if (txt.highlighted) {
                    txt.tint = opt.enabled ? 0xD79847 : 0x997b55;
                } else if (opt.enabled) {
                    txt.tint = opt.selected ? 0x64BEE3 : 0x2680A9;
                } else {
                    txt.tint = 0x888888;
                }

            }
            if (opt.selected) {
                this.cursor.y = opt.texts[0].y;
            }
        }
    }

    update(cursors, keys) {
        if (!this.dialogSprite.visible) return;
        if (this.minigame) {
            this.minigame.updateInput(cursors, keys);
            return;
        }
        let selected = this.options.find(o => o.selected);
        if (selected) {
            let si = this.options.indexOf(selected);
            if (cursors.down.justDown) {
                selected.selected = false;
                do {
                    si = (si + 1) % this.options.length;
                } while (!this.options[si].enabled);
                this.options[si].selected = true;
                this.redrawOptions();
            } else if (cursors.up.justDown) {
                selected.selected = false;
                do {
                    si = (si - 1 + this.options.length) % this.options.length;
                } while (!this.options[si].enabled);
                this.options[si].selected = true;
                this.redrawOptions();
            } else if (keys.enter.justDown || keys.space.justDown) {
                game.sounder.play('drop-2');
                let onAnyClick = this.onAnyClick;
                let anyCb = false;
                if (selected.callback) {
                    selected.callback();
                    anyCb = true;
                }
                if (onAnyClick) {
                    onAnyClick();
                    anyCb = true;
                }
                if (!anyCb) {
                    console.warn("There is no callback for option", selected.text.text);
                }
            }
        } else {
            //this is to force rest corresponding flags
            keys.enter.justDown;
            keys.space.justDown
            cursors.down.justDown
            cursors.up.justDown
        }
    }
}


// WEBPACK FOOTER //
// ./src/states/ui/dialog_ui.js